module.exports = __webpack_public_path__ + "static/media/EX_FINISHED_alt_5.5f02146b.mp3";